export const disabledNativeFieldClassNames = `
  tw:disabled:pointer-events-none
  tw:disabled:cursor-not-allowed
  tw:disabled:bg-sq-light-gray
  tw:disabled:text-sq-darkish-gray
  tw:disabled:dark:bg-sq-dark-disabled-gray
  tw:disabled:dark:text-sq-dark-text/30
`;
